import { AuthProvider } from './contexts/AuthContext';
// import { ItemsProvider } from './contexts/ItemsContext';
// import { FilterProvider } from './contexts/FilterContext';
import { ItemFilterProvider } from './contexts/ItemFilterContext';
import { AppRouter } from './routes/AppRouter';
// import './App.css'; // 【修正1】ここを削除（またはコメントアウト）！
import { MastersProvider } from './contexts/MastersContext';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Amplify } from 'aws-amplify';
import { AuthHandler } from './components/AuthHandler';
import { AppToaster } from './components/common/AppToaster';
import { AxiosError } from 'axios';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'ap-northeast-1_QgkvsYag6',
      userPoolClientId: '5snlp181vsn93bfkoqi8g8e22o',
    }
  }
});

// QueryClientにリトライ制御のオプションを追加
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        if (error instanceof AxiosError) {
          const status = error.response?.status;
          // 400番台のエラーなら、リトライせずに一発で諦める
          if (status && status >= 400 && status < 500) {
            return false;
          }
        }
        // 500系のサーバーエラーや通信断の場合は3回までリトライする
        return failureCount < 3;
      },
    },
  },
});

function App() {
  return (
    // QueryClientProvider を一番外側にします。
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <AuthProvider>
          <BrowserRouter>
            <MastersProvider>
              <ItemFilterProvider>
                <AuthHandler />
                <AppRouter />
              </ItemFilterProvider>
            </MastersProvider>
          </BrowserRouter>
      </AuthProvider>
      <AppToaster />
    </QueryClientProvider>
  );
}

export default App;